export const Computed = {
  computed: {
    hasContentUrl() {
      return typeof this.content === 'string';
    }
  }
};

export const Props = {
  props: {
    content: {
      type: [String, Object],
      required: true,
      validator(value) {
        return (typeof value === 'string' || (Object.keys(value).length !== 0 && value.constructor === Object));
      }
    },
    sliderHash: {
      type: [String]
    }
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/mixins.js